"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _finalFormArrays = _interopRequireDefault(require("final-form-arrays"));
var _components = require("@folio/stripes/components");
var _FormModal = _interopRequireDefault(require("../../FormModal"));
var _CustomPropertiesFilterFieldArray = _interopRequireDefault(require("./CustomPropertiesFilterFieldArray"));
var _hooks = require("../../hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CustomPropertyFiltersForm = _ref => {
  let {
    customProperties,
    editingFilters,
    filters,
    handlers: {
      closeEditModal,
      openEditModal
    },
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    labelOverrides = {},
    onSubmit
  } = _ref;
  const kintIntl = (0, _hooks.useKintIntl)(passedIntlKey, passedIntlNS);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
      onClick: openEditModal,
      children: kintIntl.formatKintMessage({
        id: 'customProperty.editCustomPropertyFilters',
        overrideValue: labelOverrides.editCustomPropertyFilters
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormModal.default, {
      initialValues: {
        filters: filters.length ? filters : [{
          rules: [{}]
        }]
      },
      labelOverrides: {
        saveAndClose: kintIntl.formatKintMessage({
          id: 'apply',
          overrideValue: labelOverrides.apply
        })
      },
      modalProps: {
        dismissible: true,
        enforceFocus: false,
        label: kintIntl.formatKintMessage({
          id: 'customProperty.filterBuilder',
          overrideValue: labelOverrides.filterBuilder
        }),
        onClose: closeEditModal,
        open: editingFilters,
        size: 'medium'
      },
      mutators: {
        ..._finalFormArrays.default
      },
      onSubmit: onSubmit,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CustomPropertiesFilterFieldArray.default, {
        customProperties: customProperties,
        labelOverrides: labelOverrides
      })
    })]
  });
};
CustomPropertyFiltersForm.propTypes = {
  customProperties: _propTypes.default.arrayOf(_propTypes.default.object),
  editingFilters: _propTypes.default.bool,
  filters: _propTypes.default.arrayOf(_propTypes.default.object),
  handlers: _propTypes.default.shape({
    closeEditModal: _propTypes.default.func.isRequired,
    openEditModal: _propTypes.default.func.isRequired
  }),
  intlKey: _propTypes.default.string,
  intlNS: _propTypes.default.string,
  labelOverrides: _propTypes.default.object,
  onSubmit: _propTypes.default.func.isRequired
};
var _default = exports.default = CustomPropertyFiltersForm;